import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import TemplatesPage from "@/pages/TemplatesPage";
import DesignerPage from "@/pages/DesignerPage";
import ConfigurePage from "@/pages/ConfigurePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TemplatesPage />} />
        <Route path="/configure" element={<ConfigurePage />} />
        <Route path="/designer" element={<DesignerPage />} />
        <Route path="/designer/:templateId" element={<DesignerPage />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;
